// extracted by mini-css-extract-plugin
export default {"container":"Nats_container__99sJS","containerInner":"Nats_containerInner__xBCOD","header":"Nats_header__IRpsZ"};